export default __webpack_public_path__ + "static/media/remos-signal-flex.2cf75d6a.png";